module.exports = __webpack_public_path__ + "static/zenduty-white-full-transparent-bg-2a7c832afdb3ae52c9e47f163210884c.png";